<template>
  <button
    class="w-full h-full flex items-center justify-center rounded p-2 shadow text-white"
    :class="isLiked
      ? 'bg-red-500 hover:bg-red-600'
      : 'bg-black/45 hover:bg-neutral-light hover:text-neutral-dark'"
    @click="toggleLike"
  >
    <i class="ph ph-heart" :class="{ 'ph-fill': isLiked }"></i>
  </button>
</template>

<script setup>
import { ref } from 'vue';
import client from '../http/client.js';

const props = defineProps({
  propertyId: { type: Number, required: true },
  liked: { type: Boolean, default: false },
});

const isLiked = ref(props.liked);
const loading = ref(false);

async function toggleLike() {
  if (loading.value) return;

  loading.value = true;

  try {
    if (isLiked.value) {
      await client.delete(`/website/favorites/${props.propertyId}`);
      isLiked.value = false;
    } else {
      await client.post(`/website/favorites/${props.propertyId}`);
      isLiked.value = true;
    }
  } catch (error) {
    if (error.response?.status === 409) {
      isLiked.value = true;
    }
  } finally {
    loading.value = false;
  }
}
</script>
